import './table.css';

import React from 'react';

import { cn } from '@/services/utils';

const TableHeader = React.forwardRef<
    HTMLTableSectionElement,
    React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, ref) => {
    return (
        <thead
            ref={ref}
            className={cn(
                'table-header tw-bg-fill-secondary tw-sticky tw-top-0 tw-z-10',
                className,
            )}
            {...props}
        />
    );
});

const TableHead = React.forwardRef<
    HTMLTableCellElement,
    React.ThHTMLAttributes<HTMLTableCellElement> & {
        pinned?: boolean,
        leftPinned?: boolean,
        pinnedPosition?: number,
        // LAX-10037: same as TableCell — explicit sticky offsets so
        // multi-column pinning can stack. `pinnedPosition` is kept for
        // backward compatibility with existing right-pin callers.
        leftOffset?: number,
        rightOffset?: number,
    }
>(({ className, pinned, leftPinned, pinnedPosition, leftOffset, rightOffset, style, ...props }, ref) => {
    const stickyStyle: React.CSSProperties = {};
    if (leftPinned) {
        stickyStyle.left = leftOffset ?? 0;
    }
    if (pinned) {
        stickyStyle.right = rightOffset ?? pinnedPosition ?? 0;
    }
    return (
        <th
            ref={ref}
            style={{ ...stickyStyle, ...(style ?? {}) }}
            className={cn(
                'table-head tw-bg-fill-secondary tw-h-9 tw-px-2 tw-py-2.5 tw-text-left tw-align-middle tw-text-t-primary [&:has([role=checkbox])]:tw-pr-0',
                pinned ? 'pinned' : '',
                leftPinned ? 'left-pinned-header' : '',
                className,
            )}
            {...props}
        />
    );
});

TableHeader.displayName = 'TableHeader';
TableHead.displayName = 'TableHead';

export { TableHead,TableHeader };
